<template>
    <div
        class="relative w-full h-auto max-w-hd flex flex-col gap-2"
        :class="containerless ? 'col-span-full md:col-start-2 md:col-end-12 lg:col-start-3 lg:col-end-11' : ''"
    >
        <ResponsiveMedia
            v-if="naturalHeight"
            :media-id="mediaId"
            :kind="kind"
            :asset-id="assetId"
            :priority="priority"
            :autoplay="content?.autoplays"
            :playing="content?.autoplays"
            :loop="content?.autoplays"
            :muted="content?.autoplays"
            :controls="!content?.autoplays"
            css-class="inset-0 w-full h-full object-cover max-h-screen"
        />
        <div
            v-else
            class="relative aspect-video max-h-[100dvh] w-full overflow-hidden"
            :class="{'!fixed inset-0': content?.sticky}"
        >
            <ResponsiveMedia
                :media-id="mediaId"
                :kind="kind"
                :asset-id="assetId"
                :priority="priority"
                :autoplay="content?.autoplays"
                :playing="content?.autoplays"
                :loop="content?.autoplays"
                :muted="content?.autoplays"
                :controls="!content?.autoplays"
                css-class="absolute inset-0 h-full w-full object-cover"
            />
        </div>
        <div v-if="get_localized_value(content?.text)" :class="containerless ? 'col-start-1' : 'container self-center'">
            <h1 class="text-caption text-dark-blue/75 col-span-full">{{ get_localized_value(content?.text) }}</h1>
        </div>
    </div>
</template>

<script lang="ts" setup>
import ResponsiveMedia from '~/components/ResponsiveMedia.vue'
import type { MediaKind } from '#layers/cms/shared/types/MediaBucket'

const { get_value: get_localized_value } = useLocalizedValue()

const props = defineProps({
    content: {
        type: Object as PropType<{ media?: string, text?: unknown, sticky?: boolean, autoplays?: boolean }>,
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    },
    containerless: {
        type: Boolean,
        default: false,
    },
    priority: {
        type: Boolean,
        default: false,
    },
    // VideoWithText.vue's original layout never cropped the video into a fixed aspect ratio —
    // it rendered at its own natural height (capped by max-h-screen). Set by that legacy wrapper
    // only, to keep its production rendering pixel-identical; new content uses the cropped/
    // sticky-capable aspect-video layout below by default.
    naturalHeight: {
        type: Boolean,
        default: false,
    },
    // Set by legacy video-with-text / image (with-text-overlay) wrappers — see MediaWithTextBlock.vue.
    kind: {
        type: String as PropType<MediaKind>,
        default: undefined,
    },
    assetId: {
        type: String,
        default: undefined,
    },
})
const mediaId = computed(() => props.kind ? undefined : props.content?.media)

</script>
